import Backbone from "backbone";
import {pathname} from "../../common/others/Configuration";
import $ from "jquery";

export default Backbone.View.extend({

		events: {
			"click .js-DeezerLogin": "login",
			"click .js-DeezerLogout": "logout"
		},

		initialize: function () {
			if (DZ) {
				this.initDeezer();
			}
		},

		initDeezer: function () {
			// get Deezer api conf
			var appId;
			var returnUrl;
			var dzRoot = this.$el.find('#dz-root');
			if (dzRoot.length) {
				appId = dzRoot.data('appid');
				returnUrl = dzRoot.data('returnurl');
				if (appId && returnUrl) {
					// init Deezer sdk
					DZ.init({
						appId: appId,
						channelUrl: returnUrl
					});
				}
			}
		},

		login: function () {
			if (DZ && DZ.initialized) {
				DZ.login(function (response) {
					if (response.authResponse.accessToken) {
						// set Deezer access token
						$.ajax({
							url: pathname + '/account/synchro-deezertoken?access_token=' + response.authResponse.accessToken,
							type: 'POST',
							success: function () {
								// reload page to apply Deezer login
								window.location.reload();
							},
							error: function () {
								// error on Fnac server, logout from Deezer
								DZ.logout();
							}
						});
					}
				}, { scope: 'manage_library,offline_access' });
			}
		},

		logout: function () {
			if (DZ && DZ.initialized) {
				DZ.logout();
			}
		}
	});
